import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-denials-audits',
  templateUrl: './denials-audits.component.html',
  styleUrls: ['./denials-audits.component.scss']
})
export class DenialsAuditsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/providers-billing/denials-audits/denials-audits.component.ts